import { Plugin } from '@ckeditor/ckeditor5-core'
import { ViewModel, addListToDropdown, createDropdown } from '@ckeditor/ckeditor5-ui'
import { Collection } from '@ckeditor/ckeditor5-utils'

export default class TagsUI extends Plugin {
    init() {
        const editor = this.editor
        const tags = editor.config.get('tagsConfig.types');

        editor.ui.componentFactory.add('tags', locale => {
            const dropdownView = createDropdown(locale)

            dropdownView.class = 'custom-tags-dropdown'

            addListToDropdown(dropdownView, getDropDownItemsDefinitions(tags))

            dropdownView.buttonView.set({
                label: trans('settings.tags_title'),
                tooltip: `${trans('settings.tags_title')} (#)`,
                withText: true,
            })

            const command = editor.commands.get('insertTags')
            dropdownView.bind('isEnabled').to(command)

            this.listenTo(dropdownView, 'execute', evt => {
                editor.execute('insertTags', { value: evt.source.commandParam })
                editor.editing.view.focus()
            })

            return dropdownView
        })
    }

}

function getDropDownItemsDefinitions(tags) {
    const itemDefinitions = new Collection()

    for (const tag of tags) {
        const definition = {
            type: 'button',
            model: new ViewModel({
                commandParam: tag,
                label: tag.name,
                labelStyle: 'border-left:5px solid ' + tag.color + ';padding-left:10px;',
                withText: true,
            })
        }

        itemDefinitions.add(definition)
    }

    return itemDefinitions
}
